'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var ipns = require('ipns');

var crypto = require('libp2p-crypto');

var PeerId = require('peer-id');

var errcode = require('err-code');

var debug = require('debug');

var log = debug('ipfs:ipns:resolver');
log.error = debug('ipfs:ipns:resolver:error');

var _require = require('interface-datastore'),
    Errors = _require.Errors;

var ERR_NOT_FOUND = Errors.notFoundError().code;
var defaultMaximumRecursiveDepth = 32;

var IpnsResolver = /*#__PURE__*/function () {
  function IpnsResolver(routing) {
    _classCallCheck(this, IpnsResolver);

    this._routing = routing;
  }

  _createClass(IpnsResolver, [{
    key: "resolve",
    value: function () {
      var _resolve = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(name, options) {
        var recursive, nameSegments, key, depth, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = options || {};

                if (!(typeof name !== 'string')) {
                  _context.next = 3;
                  break;
                }

                throw errcode(new Error('invalid name'), 'ERR_INVALID_NAME');

              case 3:
                options = options || {};
                recursive = options.recursive && options.recursive.toString() === 'true';
                nameSegments = name.split('/');

                if (!(nameSegments.length !== 3 || nameSegments[0] !== '')) {
                  _context.next = 8;
                  break;
                }

                throw errcode(new Error('invalid name'), 'ERR_INVALID_NAME');

              case 8:
                key = nameSegments[2]; // Define a maximum depth if recursive option enabled

                if (recursive) {
                  depth = defaultMaximumRecursiveDepth;
                }

                _context.next = 12;
                return this.resolver(key, depth);

              case 12:
                res = _context.sent;
                log("".concat(name, " was locally resolved correctly"));
                return _context.abrupt("return", res);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function resolve(_x, _x2) {
        return _resolve.apply(this, arguments);
      }

      return resolve;
    }() // Recursive resolver according to the specified depth

  }, {
    key: "resolver",
    value: function () {
      var _resolver = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(name, depth) {
        var errMsg, res, nameSegments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(depth === 0)) {
                  _context2.next = 4;
                  break;
                }

                errMsg = "could not resolve name (recursion limit of ".concat(defaultMaximumRecursiveDepth, " exceeded)");
                log.error(errMsg);
                throw errcode(new Error(errMsg), 'ERR_RESOLVE_RECURSION_LIMIT');

              case 4:
                _context2.next = 6;
                return this._resolveName(name);

              case 6:
                res = _context2.sent;
                nameSegments = res.split('/'); // If obtained a ipfs cid or recursive option is disabled

                if (!(nameSegments[1] === 'ipfs' || !depth)) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt("return", res);

              case 10:
                return _context2.abrupt("return", this.resolver(nameSegments[2], depth - 1));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function resolver(_x3, _x4) {
        return _resolver.apply(this, arguments);
      }

      return resolver;
    }() // resolve ipns entries from the provided routing

  }, {
    key: "_resolveName",
    value: function () {
      var _resolveName2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(name) {
        var peerId, _ipns$getIdKeys, routingKey, record, ipnsEntry, pubKey;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                peerId = PeerId.createFromCID(name);
                _ipns$getIdKeys = ipns.getIdKeys(peerId.toBytes()), routingKey = _ipns$getIdKeys.routingKey;
                _context3.prev = 2;
                _context3.next = 5;
                return this._routing.get(routingKey.toBuffer());

              case 5:
                record = _context3.sent;
                _context3.next = 14;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](2);
                log.error(_context3.t0);

                if (!(_context3.t0.code === ERR_NOT_FOUND)) {
                  _context3.next = 13;
                  break;
                }

                throw errcode(new Error("record requested for ".concat(name, " was not found in the network")), 'ERR_NO_RECORD_FOUND');

              case 13:
                throw errcode(new Error("unexpected error getting the ipns record ".concat(peerId.id)), 'ERR_UNEXPECTED_ERROR_GETTING_RECORD');

              case 14:
                _context3.prev = 14;
                ipnsEntry = ipns.unmarshal(record);
                _context3.next = 22;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t1 = _context3["catch"](14);
                log.error(_context3.t1);
                throw errcode(new Error('found ipns record that we couldn\'t convert to a value'), 'ERR_INVALID_RECORD_RECEIVED');

              case 22:
                if (!ipnsEntry.pubKey) {
                  _context3.next = 24;
                  break;
                }

                return _context3.abrupt("return", this._validateRecord(peerId, ipnsEntry));

              case 24:
                _context3.prev = 24;
                _context3.next = 27;
                return this._routing.get(routingKey.toBuffer());

              case 27:
                pubKey = _context3.sent;
                _context3.next = 36;
                break;

              case 30:
                _context3.prev = 30;
                _context3.t2 = _context3["catch"](24);
                log.error(_context3.t2);

                if (!(_context3.t2.code === ERR_NOT_FOUND)) {
                  _context3.next = 35;
                  break;
                }

                throw errcode(new Error("public key requested for ".concat(name, " was not found in the network")), 'ERR_NO_RECORD_FOUND');

              case 35:
                throw errcode(new Error("unexpected error getting the public key for the ipns record ".concat(peerId.id)), 'ERR_UNEXPECTED_ERROR_GETTING_PUB_KEY');

              case 36:
                _context3.prev = 36;
                // Insert it into the peer id, in order to be validated by IPNS validator
                peerId.pubKey = crypto.keys.unmarshalPublicKey(pubKey);
                _context3.next = 44;
                break;

              case 40:
                _context3.prev = 40;
                _context3.t3 = _context3["catch"](36);
                log.error(_context3.t3);
                throw errcode(new Error('found public key record that we couldn\'t convert to a value'), 'ERR_INVALID_PUB_KEY_RECEIVED');

              case 44:
                return _context3.abrupt("return", this._validateRecord(peerId, ipnsEntry));

              case 45:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 8], [14, 18], [24, 30], [36, 40]]);
      }));

      function _resolveName(_x5) {
        return _resolveName2.apply(this, arguments);
      }

      return _resolveName;
    }() // validate a resolved record

  }, {
    key: "_validateRecord",
    value: function () {
      var _validateRecord2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(peerId, ipnsEntry) {
        var pubKey;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return ipns.extractPublicKey(peerId, ipnsEntry);

              case 2:
                pubKey = _context4.sent;
                _context4.next = 5;
                return ipns.validate(pubKey, ipnsEntry);

              case 5:
                return _context4.abrupt("return", ipnsEntry.value.toString());

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function _validateRecord(_x6, _x7) {
        return _validateRecord2.apply(this, arguments);
      }

      return _validateRecord;
    }()
  }]);

  return IpnsResolver;
}();

exports = module.exports = IpnsResolver;